<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <!-- Movil: regresa al submenu de Inventario sin usar el boton atras del equipo -->
        <router-link class="btn btn-sm btn-info d-inline-flex align-items-center d-md-none mb-3 req-btn-regresar"
          :to="{ name: 'dashboard', query: { modulo: 'inv' } }">
          <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
          <span class="ml-1">Regresar al menú</span>
        </router-link>
        <h5 class="form-header">Requerimientos de Traslado</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <router-link class="btn btn-sm btn-primary" :to="{ name: 'inventario-req_traslado-nuevo', params: {} }">
                Nuevo Requerimiento &nbsp;
                <i class="fa fa-plus-square"></i>
              </router-link>
              <button type="button" @click="modalTiendaSelect()" class="btn btn-dark btn-sm">
                Cambiar Tienda
                <i class="fas fa-history"></i>
              </button>
            </div>
            <br>
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end row">
                <select class="form-control form-control-sm rounded bright" v-model="filter.origen"
                  @change="filterData(1)" title="Origen del requerimiento">
                  <option value="manual">Manuales (creados por usuarios)</option>
                  <option value="automatico">Automáticos (generados por el sistema)</option>
                  <option value="">Manuales y automáticos</option>
                </select>
                <select class="form-control form-control-sm rounded bright" v-model="filter.estado_str"
                  @change="filterData()">
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
                <input class="form-control form-control-sm rounded bright" placeholder="Filtrar Numero"
                  v-model="filter.numero" type="text" v-on:keyup.enter="filterData()" />
                <UsuariosSelectComponent class="col-sm-2" style="display: block" :current="filter" @change="filterData()"
                  @onChange="filterData()" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="filtroAplicado" class="alert py-2 small"
          :class="filtroAplicado.origen == 'manual' ? 'alert-info' : 'alert-secondary'">
          <i class="fas fa-filter"></i>
          {{ textoFiltroOrigen }}
        </div>
        <ReqTrasladoTableComponent :dataTabla="datatabla2" />
        <PaginationComponent :currentPage="currentPage" :data="datatabla2" @pagechanged="filterData" />
      </div>
    </div>
    <div class="modal fade" id="modalTiendaSelect" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Elige una tienda
            </h5>
          </div>
          <div class="modal-body">
            <select class="form-control col-12" v-model="filter.tienda" @change="filterData()">
              <option v-for="(item, key) in tiendasModal" :value="item.codigo" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clearFilterData()">
              Cerrar <i class="fas fa-times" style="float: right;"></i>
              <br>
              <small>(Se mostraran todas las tiendas)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ReqTrasladoTableComponent from "@/components/inventario/req_traslado/ReqTrasladoTableComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ReqTrasladoTableComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      datatabla2: "",
      tiendasAsignadas: [],
      // Filtro con el que se cargaron los datos que muestra la tabla (lo usa el aviso)
      filtroAplicado: null,
      // Numero de la ultima consulta enviada: evita que una respuesta vieja pise a una nueva
      ultimaConsulta: 0,
      filter: {
        tienda: "",
        // Por defecto solo los requerimientos creados por usuarios (sin los automaticos)
        origen: "manual",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    /**
     * Tiendas del modal: solo las asignadas al usuario en tienda_usuario.
     * Si no tiene asignadas, se usa el listado general del catalogo.
     */
    tiendasModal() {
      if (this.tiendasAsignadas.length > 0) {
        return this.tiendasAsignadas;
      }
      return this.tiendas;
    },
    /**
     * Texto que indica al usuario que requerimientos esta viendo.
     * Se arma con el filtro con el que se cargo la tabla (filtroAplicado), no con lo
     * seleccionado en pantalla, para que el aviso siempre coincida con los datos.
     */
    textoFiltroOrigen() {
      if (!this.filtroAplicado) {
        return "";
      }
      const aplicado = this.filtroAplicado;
      let tienda = "de todas las tiendas";
      if (aplicado.tienda) {
        const lista = [...(this.tiendasModal || []), ...(this.tiendas || [])];
        const encontrada = lista.find((item) => item.codigo == aplicado.tienda);
        tienda = encontrada
          ? `de la tienda ${encontrada.codigo} - ${encontrada.nombre}`
          : `de la tienda ${aplicado.tienda}`;
      }
      if (aplicado.origen == "manual") {
        return `Mostrando solo los requerimientos manuales (creados por usuarios) ${tienda}. ` +
          "Los requerimientos automáticos generados por el sistema no se muestran; " +
          "para verlos seleccione \"Automáticos\" en el filtro de origen.";
      }
      if (aplicado.origen == "automatico") {
        return `Mostrando solo los requerimientos automáticos (generados por el sistema) ${tienda}.`;
      }
      return `Mostrando requerimientos manuales y automáticos ${tienda}.`;
    },
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.inicializarTienda();
  },
  methods: {
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    /**
     * Define la tienda inicial segun las asignaciones del usuario en tienda_usuario.
     * - Tiene tienda predeterminada: se filtra directo por ella, sin modal.
     * - Tiene una sola tienda asignada: se filtra directo por ella, sin modal.
     * - Sin tiendas asignadas o varias sin predeterminada: se muestra el modal.
     */
    inicializarTienda() {
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
        quitar_paginacion: true,
      })
        .then((response) => {
          const asignadas = Array.isArray(response.data)
            ? response.data
            : response.data.results || [];
          this.tiendasAsignadas = asignadas
            .map((item) => item.tienda)
            .filter((tienda) => tienda && tienda.activa);
          const predeterminada = asignadas.find((item) => item.predeterminada);
          const unica = asignadas.length === 1 ? asignadas[0] : null;
          const tiendaInicial = predeterminada || unica;
          if (tiendaInicial && tiendaInicial.tienda) {
            this.filter.tienda = tiendaInicial.tienda.codigo;
            this.filterData();
            return;
          }
          this.mostrarSeleccionTienda();
        })
        .catch(() => {
          this.mostrarSeleccionTienda();
        });
    },
    mostrarSeleccionTienda() {
      this.refreshData();
      $("#modalTiendaSelect").modal("show");
    },
    /**
     * Consulta el listado y guarda el filtro con el que se cargaron los datos.
     * Si mientras tanto se envio otra consulta, la respuesta vieja se descarta.
     * Resuelve true si la respuesta se aplico a la tabla.
     */
    consultar(params) {
      this.ultimaConsulta += 1;
      const consulta = this.ultimaConsulta;
      const aplicado = { tienda: params.tienda || "", origen: params.origen || "" };
      return DynamicService.fetch("inv", "req_traslado", params).then((response) => {
        if (consulta !== this.ultimaConsulta) {
          return false;
        }
        this.datatabla2 = response.data;
        this.filtroAplicado = aplicado;
        return true;
      });
    },
    refreshData() {
      this.consultar({
        origen: this.filter.origen,
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      this.consultar({
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        fecha_creacion: this.filter.fecha_creacion,
        tienda: this.filter.tienda,
        origen: this.filter.origen,
        estado: this.filter.estado_str,
        usuario: this.filter.usuario.id,
        numero: this.filter.numero,
      }).then((aplicada) => {
        if (aplicada) {
          $("#modalTiendaSelect").modal("hide");
        }
      });
    },
    /**
     * Limpia los filtros (boton X y "Cerrar" del modal) y vuelve a cargar,
     * para que la tabla y el aviso muestren lo mismo.
     */
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.usuario = "";
      this.filter.tienda = "";
      this.filterData(1);
    },
  },
};
</script>

<style scoped>
.req-btn-regresar {
  min-height: 36px;
}
</style>
